export default {
  // Commune specific texts
  region: 'Region',
}
